export const CATEGORY_COLLECTION = 'CategoryCollection'
export const BRAND_COLLECTION = 'BrandCollection'
export const PRODUCT_COLLECTION = 'ProductCollection'
export const SELLER_COLLECTION = 'SellerCollection'
export const HOME = 'HOME'
export const PRODUCT_DETAIL = 'ProductDetail'
export const CHECKOUT_PAGE = 'CheckoutPage'
export const TOKEN = 'token'
export const CHECKOUT_KEY = 'checkout'
export const AUTH_TOKEN_KEY = 'auth_token'
export const USER_DATA_KEY = 'userData'
export const WEBSITELOGO = 'websiteLogo'
export const BRANDNAME = 'BrandName'
export const CATEGORYNAME = 'CategoryName'
export const PROMOTIONS = 'Promotions'
export const SELLER = 'SELLER'

// aria-labels
export const NEXTSLIDE = 'showNextSlide'
export const PREVIOUSSLIDE = 'showPreviousSlide'
export const MENUOPEN = 'menuOpen'
export const ANDROIDLABEL = 'androidUrl'
export const ISTORELABEL = 'istoreUrl'
export const TWITTERLABEL = 'twitterUrl'
export const FACEBOOKLABEL = 'facebookUrl'
export const YOUTUBELABEL = 'youtubeUrl'
export const INSTAGRAMLABEL = 'instagramUrl'
export const STORE_ID = 'storeId'
